"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCookie = void 0;
var getCookie = function (name) {
    var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    var value = match === null || match === void 0 ? void 0 : match[2];
    return value;
};
exports.getCookie = getCookie;
